import { getApolloClient } from 'owa-apollo';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import removeAccountById from '../actions/removeAccountById';
import { RemoveAccountDocument } from '../graphql/__generated__/RemoveAccountMutation.interface';
import removeAccountSucceeded from '../mutators/removeAccountSucceeded';
import getProfileStore from '../store/profileStore';

orchestrator(removeAccountById, async actionMessage => {
    const { accountSourceId } = actionMessage;

    // This if statement is a precondition, not error handling, the UI or any other
    // callers are expected to call this function with the right conditions.
    if (getProfileStore().accountSources.length === 1) {
        trace.warn('Removing the only account is not allowed');
        return;
    }

    // Also precondition
    if (accountSourceId === getProfileStore().selectedAccountSourceId) {
        trace.warn('Removing the selected account is not allowed');
        return;
    }

    const apolloClient = getApolloClient();
    await apolloClient.mutate({
        mutation: RemoveAccountDocument,
        variables: {
            id: accountSourceId,
        },
    });

    // TODO Investigate if spinner is needed on remove account and if so, implement it
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/116306
    removeAccountSucceeded(accountSourceId);
});
